import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';

import { Store } from '@ngrx/store';

import { selectUser } from '../../../../store/app.selectors';

import { IDealer } from '../../../../modules/chat/interfaces/IDealer';
import { selectDealer } from '../../../../modules/chat/store/chat.actions';
import { AppStateWithChat } from '../../../../modules/chat/store/chat.reducer';
import { IUserProfile } from '../../../../modules/user/interfaces/IUserProfile';
import { NgxMessagingAwayModalComponent } from '../../../chat/external-components/ngx-messaging-away-modal/ngx-messaging-away-modal.component';
import { cancelAway } from '../../../user/store/user.actions';
import { AlertModalComponent } from '../alert/alert.component';
import { BaseComponent } from '../base/base.component';
import { ProfileModalComponent } from '../profile-modal/profile-modal.component';

@Component({
  selector: 'ngx-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProfileComponent extends BaseComponent {
  private dialog = inject(MatDialog);
  private store = inject(Store<AppStateWithChat>);

  currentUserSesion = toSignal(this.store.select(selectUser), { initialValue: null as IUserProfile | null });

  openProfile(): void {
    this.dialog.open(ProfileModalComponent, {
      panelClass: 'dialog-container-custom',
      width: '25vw',
    });
  }

  cancelAway(): void {
    this.dialog
      .open(AlertModalComponent, {
        data: {
          title: 'Cancel away mode',
          message: 'Are you sure to cancel away mode?',
        },
      })
      .afterClosed()
      .subscribe((res: boolean) => {
        if (res) {
          this.store.dispatch(cancelAway());
        }
      });
  }

  selectDealer(dealer: IDealer) {
    this.store.dispatch(selectDealer({ dealer }));
  }

  openAwayModal(): void {
    this.dialog.open(NgxMessagingAwayModalComponent, {
      panelClass: 'dialog-container-custom',
      width: '25vw',
    });
  }
}
